import { render, staticRenderFns } from "./iconHigiene-white.vue?vue&type=template&id=90a22294&scoped=true&"
import script from "./iconHigiene-white.vue?vue&type=script&lang=js&"
export * from "./iconHigiene-white.vue?vue&type=script&lang=js&"
import style0 from "./iconHigiene-white.vue?vue&type=style&index=0&id=90a22294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a22294",
  null
  
)

export default component.exports